import { line } from "../monitor/monitor-generator";

const fullcontHandler = require("./fullcont-handler");
const dtHandler = require("../dt/dt-handler");

export function showFullcont(detail, data, config) {
  const scrimFullcont = document.getElementById("scrim_fullcont");
  fullcontHandler.show({ id: detail.id }, scrimFullcont);
  fullcontHandler.setDbid(detail);

  config.fields.forEach((field) => {
    const selector = config.id + field + " input";
    const element = document.querySelector(selector);
    if (element) {
      element.value = data[0][field] || "";
    }
  });

  dtHandler.highlightTr(detail);
}

//invoices
export function renderUnpaidInvoices(data, config) {
  const container =
    typeof config.container === "string"
      ? document.getElementById(config.container)
      : config.container;

  if (!container) {
    console.log("Contenedor no encontrado para render unpaid invoices");
    return;
  }

  container.innerHTML = ""; // limpia el contenido actual

  data.forEach((group) => {
    // Crear título como elemento
    const title = document.createElement("div");
    title.classList.add("row");
    title.style.textAlign = "center";
    title.innerHTML = `
            <div class="c100">
                <label class="font-card-title overdue_age" style="margin-top:0;">${
                  group.overdue_age + " - " + group.ageDueAmount
                }</label>
            </div>
        `;

    // Crear bloque principal
    const block = document.createElement("div");
    block.classList.add(config.blockClass || "multitable-card-report");

    const header = document.createElement("div");
    header.className = "header-entity-fields";
    header.innerHTML = config.headerHtml || "";

    const linesContainer = document.createElement("div");
    linesContainer.className = "cont unpaid-invoices-lines";

    const unpaidList = JSON.parse(group.unpaidBill);

    unpaidList.forEach((item) => {
      const htmlString = config.lineRenderer(item.id, item);
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = htmlString.trim();
      const line = tempDiv.firstElementChild;

      if (typeof config.afterLineRender === "function") {
        config.afterLineRender(line, item);
      }

      linesContainer.appendChild(line);
    });

    block.appendChild(header);
    block.appendChild(linesContainer);

    // Agrega primero el título, luego el bloque
    container.appendChild(title);
    container.appendChild(block);
  });
}

//profits
export function renderProfitInvoices(data, config) {
  const container =
    typeof config.container === "string"
      ? document.getElementById(config.container)
      : config.container;

  if (!container) {
    console.log("Contenedor no encontrado para renderProfitInvoices");
    return;
  }

  container.innerHTML = ""; // Limpiar el contenido actual

  // 1. Agrupar datos por período
  const groupedData = {};
  data.forEach((item) => {
    const period = item.period || "Unknown";
    if (!groupedData[period]) groupedData[period] = [];
    groupedData[period].push(item);
  });

  // 2. Orden opcional de los periodos
  const order = [
    "Last 24 hours",
    "Last 7 days",
    "Last 15 days",
    "Last 30 days",
    "Last 90 days",
    "Over 90 days",
    "Unknown"
  ];

  // 3. Recorrer los grupos ordenadamente
  Object.keys(groupedData)
    .sort((a, b) => order.indexOf(a) - order.indexOf(b))
    .forEach((period) => {
      const items = groupedData[period];

      // Crear título del período
      const title = document.createElement("div");
      title.classList.add("row");
      title.style.textAlign = "center";
      title.innerHTML = `
        <div class="c100">
          <label class="font-card-title overdue_age" style="margin-top:0;">
            ${period}
          </label>
        </div>
      `;

      // Crear bloque de tabla
      const block = document.createElement("div");
      block.classList.add(config.blockClass || "multitable-card-report");

      const header = document.createElement("div");
      header.className = "header-entity-fields";
      header.innerHTML = config.headerHtml || "";

      const linesContainer = document.createElement("div");
      linesContainer.className = "cont unpaid-invoices-lines";

      // Renderizar cada línea
      items.forEach((item) => {
        const htmlString = config.lineRenderer(item.profit_id, item);
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = htmlString.trim();
        const line = tempDiv.firstElementChild;

        if (typeof config.afterLineRender === "function") {
          config.afterLineRender(line, item);
        }

        linesContainer.appendChild(line);
      });

      block.appendChild(header);
      block.appendChild(linesContainer);

      // Agregar al contenedor
      container.appendChild(title);
      container.appendChild(block);
    });
}


export function autoAssignValuesByClass(container, data) {
  
  for (const key in data) {
    const input = container.querySelector(`.${key} input`);
    if (input) {
      input.value = data[key] || "";
    }
  }
}
